import React from 'react';
import ReactDOM from 'react-dom/client';
import BootstrapShell from './components/bootstrap/BootstrapShell';
import { applyThemeFromStorage } from './utils/theme';
import { APP_NAME } from './config/brandingConfig';
import { shouldRunAuthenticatedBootstrap } from './utils/bootstrapRoutePolicy';
import { preloadAuthenticatedWorkspace } from './utils/workspacePreload';

async function mountApplication(root) {
  const [{ default: App }, { default: AppProviders }] = await Promise.all([
    import('./App'),
    import('./context/AppProviders'),
  ]);

  root.render(
    <React.StrictMode>
      <AppProviders>
        <App />
      </AppProviders>
    </React.StrictMode>,
  );
}

/**
 * Boot the SPA. Public routes mount immediately with lazy Suspense fallbacks.
 * Authenticated workspace routes show BootstrapShell while modules preload.
 */
export async function bootstrapApp() {
  applyThemeFromStorage();
  document.title = APP_NAME;

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element #root was not found.');
  }

  const root = ReactDOM.createRoot(rootElement);

  if (shouldRunAuthenticatedBootstrap()) {
    let progress = { done: 0, total: 0, failed: 0, phase: 'core', label: 'Core services' };

    const renderShell = () => {
      root.render(<BootstrapShell progress={progress} />);
    };

    renderShell();

    await preloadAuthenticatedWorkspace((nextProgress) => {
      progress = nextProgress;
      renderShell();
    });
  }

  await mountApplication(root);
}
